import { Center, IconButton, Img, Wrap } from '@chakra-ui/react'
import { faTrash } from '@fortawesome/pro-regular-svg-icons'
import { useCallback } from 'react'

import Icon from '@/components/UI/Icon/Icon'

import type { FileUpload } from './types'

export default function FileUploadPreview({
  disabled,
  uploads,
  onDeleteUpload,
}: {
  disabled?: boolean
  uploads: FileUpload[]
  onDeleteUpload: (uniqueIdentifier: string) => void
}): JSX.Element | null {
  const handleDeleteClick = useCallback(
    (uniqueIdentifier: string) => {
      if (disabled !== true) {
        onDeleteUpload(uniqueIdentifier)
      }
    },
    [disabled, onDeleteUpload]
  )

  if (uploads.length === 0) {
    return null
  }

  return (
    <Wrap p="16px">
      {uploads.map(({ uniqueIdentifier, file }) => (
        <Wrap key={uniqueIdentifier} spacing="50px">
          <Center
            p="4px"
            borderRadius="8px"
            position="relative"
            border="2px solid"
            borderColor="border.muted"
          >
            <Img
              src={URL.createObjectURL(file)}
              height="70px"
              maxWidth="150px"
              objectFit="contain"
            />
            <IconButton
              variant="icon"
              isRound
              bg="bg.subtle"
              position="absolute"
              aria-label="Delete image"
              top="-10px"
              right="-10px"
              disabled={disabled}
              onClick={() => handleDeleteClick(uniqueIdentifier)}
              icon={<Icon size="md" faIcon={faTrash} />}
            />
          </Center>
        </Wrap>
      ))}
    </Wrap>
  )
}
